import Moment from "moment";
import DateSelection from "./date-selection";

export default class DateWeekSelection extends DateSelection {

    constructor() {
        super();
        this.dateStep = 'week';
        this.withSunday = false;
    }

    startOfRange(date) {
        return Moment(date).startOf('month').startOf('week');
    }

    endOfRange(date) {
        return Moment(date).endOf('month').startOf('week');
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/components/week-date-selection/date-week-selection.js